import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';
import { commonMessages as termsCommonMessages } from '@/messages/common';

export const messages = defineMessages({
  chooseYourRetailer: {
    defaultMessage: 'Choose Your Retailer',
    id: 'availabilityRequest.chooseYourRetailer',
  },
  maxCommentsMsg: {
    defaultMessage: '3000 characters maximum.',
    id: 'availabilityRequest.maxCommentsMsg',
  },
  selectRetailerPlaceholder: {
    defaultMessage: 'Select a retailer',
    id: 'availabilityRequest.selectRetailerPlaceholder',
  },
  errorChooseYourRetailer: {
    defaultMessage: 'Please choose Your Retailer',
    id: 'availabilityRequest.errorChooseYourRetailer',
  },
  storeLocator: {
    defaultMessage: 'Store Locator',
    id: 'availabilityRequest.storeLocator',
  },
  wouldLikeTo: {
    defaultMessage: 'I would like to...',
    id: 'availabilityRequest.wouldLikeTo',
  },
});

export const ConfirmLegal = (
  <FormattedMessage
    defaultMessage='By clicking "Submit", you confirm you have read the {policyLink} and have read and accepted {breitlingTermsOfUse}.'
    id='availabilityRequest.confirmLegal'
    values={{
      breitlingTermsOfUse: (
        <LinkWithLocale href={paths.termsOfUse.url()}>
          <FormattedMessage {...termsCommonMessages.breitlingTermsOfUse} />
        </LinkWithLocale>
      ),
      policyLink: (
        <LinkWithLocale href={paths.privacyPolicy.url()}>
          <FormattedMessage {...termsCommonMessages.breitlingPrivacyPolicy} />
        </LinkWithLocale>
      ),
    }}
  />
);

export const ThankYouMessage = (
  <FormattedMessage
    defaultMessage='Thank you for your availability request on Breitling.com.{br}A Breitling Squad member will be in touch with you soon.'
    id='availabilityRequest.thankYouMessage'
    values={{
      br: <br />,
    }}
  />
);
